"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _SettingController2 = require("./SettingController");

var _SettingController3 = _interopRequireDefault(_SettingController2);

var _dispatcher = require("../../dispatcher");

var _dispatcher2 = _interopRequireDefault(_dispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2019 New Vector Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var CustomStatusController = function (_SettingController) {
    (0, _inherits3.default)(CustomStatusController, _SettingController);

    function CustomStatusController() {
        (0, _classCallCheck3.default)(this, CustomStatusController);
        return (0, _possibleConstructorReturn3.default)(this, (CustomStatusController.__proto__ || (0, _getPrototypeOf2.default)(CustomStatusController)).apply(this, arguments));
    }

    (0, _createClass3.default)(CustomStatusController, [{
        key: "onChange",
        value: function onChange(level, roomId, newValue) {
            // Dispatch setting change so that some components that are still visible when the
            // Settings page is open (such as RoomTiles) can reflect the change.
            _dispatcher2.default.dispatch({
                action: "feature_custom_status_changed"
            });
        }
    }]);
    return CustomStatusController;
}(_SettingController3.default);

exports.default = CustomStatusController;
module.exports = exports["default"];
//# sourceMappingURL=CustomStatusController.js.map